import { render, staticRenderFns } from "./InboxWidget.vue?vue&type=template&id=6023e4c5&scoped=true&"
import script from "./InboxWidget.vue?vue&type=script&lang=js&"
export * from "./InboxWidget.vue?vue&type=script&lang=js&"
import style0 from "./InboxWidget.vue?vue&type=style&index=0&id=6023e4c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023e4c5",
  null
  
)

export default component.exports